import { useState } from "react";

import "./index.css";
import { Modal, FloatButton, Divider, Space, Switch, Input, Button, InputNumber, Select } from "antd";
import { SettingOutlined, PrinterOutlined, PlusOutlined } from "@ant-design/icons";
import Field from "./Field";

function Settings(props) {
  const [isModalOpen, setIsModalOpen] = useState(false);

  const showModal = () => {
    setIsModalOpen(true);
  };

  const showPrinter = () => {
    window.print();
  };

  const handleOk = () => {
    setIsModalOpen(false);
  };

  const handleCancel = () => {
    setIsModalOpen(false);
  };

  const updateTitle = (event) => {
    props.onSetTitle(event.target.value);
  };

  const onDeleteField = (index) => {
    const slotNames = [...props.slotNames];
    slotNames.splice(index, 1);
    props.onSetSlotNames(slotNames);
  };

  const onUpdateField = (index, value) => {
    const slotNames = [...props.slotNames];
    slotNames[index] = value;
    props.onSetSlotNames(slotNames);
  };

  const onMoveUpField = (index) => {
    if (index === 0) return;

    const slotNames = [...props.slotNames];
    const temp = slotNames[index - 1];
    slotNames[index - 1] = slotNames[index];
    slotNames[index] = temp;
    props.onSetSlotNames(slotNames);
  };

  const onMoveDownField = (index) => {
    if (index === props.slotNames.length - 1) return;

    const slotNames = [...props.slotNames];
    const temp = slotNames[index + 1];
    slotNames[index + 1] = slotNames[index];
    slotNames[index] = temp;
    props.onSetSlotNames(slotNames);
  };

  const onAddField = async () => {
    const slotNames = [...props.slotNames, "New task"];
    props.onSetSlotNames(slotNames);
  };

  return (
    <div className="Settings">
      <FloatButton.Group
        style={{
          right: 14,
        }}
      >
        <FloatButton icon={<SettingOutlined />} onClick={showModal} />
        <FloatButton icon={<PrinterOutlined />} onClick={showPrinter} />
      </FloatButton.Group>
      <Modal title="Settings" open={isModalOpen} onOk={handleOk} onCancel={handleCancel} footer={null}>
        <Space.Addon>
          <span style={{marginRight: "0.5rem"}}>Title</span>
          <Input showCount maxLength={32} onChange={updateTitle} value={props.title} />
        </Space.Addon>
        <Divider />
        <div>
          <div className="Title">Columns:</div>
          <div>
            {props.slotNames.map((name, index) => {
              return (
                <Field
                  key={`${name}-${index}`}
                  label={name}
                  onDelete={() => onDeleteField(index)}
                  onUpdate={(newValue) => onUpdateField(index, newValue)}
                  onMoveUp={() => onMoveUpField(index)}
                  onMoveDown={() => onMoveDownField(index)}
                />
              );
            })}
          </div>
          <Button icon={<PlusOutlined />} onClick={onAddField}>
            Add
          </Button>
        </div>
        <Divider />
        <div>
          <div className="Title">Custom recurrence:</div>
          <div>
            Repeat every &nbsp;
            <InputNumber
              min={1}
              max={10}
              defaultValue={1}
              value={props.repeatStep}
              onChange={props.onSetRepeatStep}
              controls={true}
              className="Number"
            />
            &nbsp;
            <Select
              defaultValue="day"
              value={props.repeatUnit}
              style={{ width: 120 }}
              onChange={props.onSetRepeatUnit}
              options={[
                { value: "day", label: "day" },
                { value: "week", label: "week" },
              ]}
            />
            .
          </div>
        </div>
        <Divider />
        <div className="Checkboxes">
          <div>
            Show weekday:{" "}
            <Switch
              defaultChecked
              checked={props.showWeekdays}
              onChange={props.onSetShowWeekdays}
              checkedChildren="On"
              unCheckedChildren="Off"
            />
          </div>
          <div>
            Print header:{" "}
            <Switch
              defaultChecked
              checked={props.shouldPrintHeader}
              onChange={props.onSetShouldPrintHeader}
              checkedChildren="On"
              unCheckedChildren="Off"
            />
          </div>
        </div>
        <div className="DateFormat">
          <div>
            Date:{" "}
            <Select
              defaultValue="YYYY-MM-DD"
              value={props.dateFormat}
              style={{ minWidth: 180 }}
              onChange={props.onSetDateFormat}
              options={[
                { value: "YYYY-MM-DD", label: "YYYY-MM-DD" },
                { value: "MM-DD", label: "MM-DD" },
                { value: "DD", label: "DD" },
                { value: "MMM", label: "MMM" },
              ]}
            />
          </div>
          <div>
            Weekday:{" "}
            <Select
              defaultValue="YYYY-MM-DD"
              disabled={!props.showWeekdays}
              value={props.weekdayFormat}
              style={{ minWidth: 80 }}
              onChange={props.onSetWeekdayFormat}
              options={[
                { value: "dddd", label: "dddd" },
                { value: "ddd", label: "ddd" },
              ]}
            />
          </div>
        </div>
        <div className="Version">Version: {process.env.REACT_APP_VERSION}</div>
      </Modal>
    </div>
  );
}

export default Settings;
